/**
 * Values must start with value to be picked up by the renderer
 */
export var AttributeValueContentType;
(function (AttributeValueContentType) {
    /**
     * Debug display
     */
    AttributeValueContentType["Debug"] = "ValueContent:debug";
    /**
     * Name, value or formatted value, depending on data type and language dependent settings
     */
    AttributeValueContentType["Value"] = "ValueContent:value";
    /**
     * Name of a value
     */
    AttributeValueContentType["Name"] = "ValueContent:name";
    /**
     * Description of a value
     */
    AttributeValueContentType["Description"] = "ValueContent:description";
    /**
     * Property of a value
     */
    AttributeValueContentType["PropertyText"] = "ValueContent:propertyText";
    /**
     * Name of its attribute
     */
    AttributeValueContentType["AttributeName"] = "ValueContent:attributeName";
    /**
     * Image of a value
     */
    AttributeValueContentType["Image"] = "ValueContent:image";
    /**
     * Recommendation score
     */
    AttributeValueContentType["Suggestion"] = "ValueContent:suggestion";
    /**
     * Help icon
     */
    AttributeValueContentType["Help"] = "ValueContent:help";
    /**
     * Price of option
     */
    AttributeValueContentType["Price"] = "ValueContent:price";
    /**
     * Type code
     */
    AttributeValueContentType["TypeCode"] = "ValueContent:typecode";
    /**
     * Item number
     */
    AttributeValueContentType["ItemNo"] = "ValueContent:itemno";
    /**
     * Quantity input
     */
    AttributeValueContentType["Quantity"] = "ValueContent:quantity";
    /** Content area used in thumbs */
    AttributeValueContentType["Content"] = "ValueContent:content";
    /** Actions area used in thumbs */
    AttributeValueContentType["Actions"] = "ValueContent:actions";
    /** Placeholder for unknown content */
    AttributeValueContentType["Unknown"] = "ValueContent:unknown";
    /** Multiple fields in one text */
    AttributeValueContentType["Multiple"] = "ValueContent:multiple";
})(AttributeValueContentType || (AttributeValueContentType = {}));
//# sourceMappingURL=AttributeValueContentType.js.map